import { branch, withHandlers } from 'recompose';
import { xor } from 'lodash';

import { isEditMode } from '../helpers/isEditMode';
import confirmModal from '../../../../../common/confirmModal';
import { LOCATIONS_ALL_ID } from '../constants';

const withAddBranch = withHandlers({
  onTabClick: props => index => () => {
    props.setActiveTab(index);
  },
});

const withEditBranch = withHandlers({
  onTabClick: props => index => () => {
    const isLocationsTab = props.tabs[props.activeTab].title.toLowerCase() === 'locations';

    let isDataChanged = !props.pristine;

    if (isLocationsTab) {
      const currentLocations = Object.keys(props.formValues).filter(locationId => locationId !== LOCATIONS_ALL_ID);
      const selectedLocations = props.selectedLocations.map(location => location.id);
      isDataChanged = !!xor(currentLocations, selectedLocations).length;
    }

    if (!isDataChanged) {
      props.setActiveTab(index);
      return;
    }

    confirmModal(
      {
        title: 'Unsaved changes',
        message: 'Would you like to save the changes before leaving this tab?',
        type: 'yesno',
        confirmButtonText: 'Yes',
        negativeButtonText: 'No',
      },
      () => {
        props.onSubmit(props.formValues).then(() => {
          props.setActiveTab(index);
        });
      },
      () => {
        props.setActiveTab(index);
        props.reset();
      }
    );
  },
});

const withOnTabClick = branch(props => isEditMode(props), withEditBranch, withAddBranch);

export default withOnTabClick;
